import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { DataService } from 'src/app/services/data.service';
import { ErrorHandlerService } from 'src/app/services/error-handler.service';
import { ToastService } from 'src/app/services/toast.service';

@Component({
  selector: 'app-one_time_password',
  templateUrl: './one_time_password.page.html',
  styleUrls: ['./one_time_password.page.scss'],
})
export class OneTimePasswordPage implements OnInit {
  mfaForm: FormGroup;
  sendingOTP=false
  OTPsent=false
  message;
  submitting=false
  errors= {};
  constructor(
    private router:Router,
    private toastSRV: ToastService,
    private fb: FormBuilder,
    private errorHandlerSRV:ErrorHandlerService,
    private dataSRV:DataService,
  ) { }
  ionViewWillEnter(){
    this.mfaForm = this.fb.group({
      one_time_password: [null, [Validators.required]],
    });
    this.sendingOTP=false
    this.OTPsent=false
    this.message;
    this.submitting=false
    this.errors= {};
  }
  ngOnInit() {
    this.mfaForm = this.fb.group({
      one_time_password: [null, [Validators.required]],
    });
  }
  sendOTP(){
    this.sendingOTP=true
    this.dataSRV.postData('account/send_email',{}).subscribe({
      next:(res:any)=>{
        this.sendingOTP=false
        if(res.status=='success'){
          this.OTPsent = res?.email_sent
          this.message = res?.message
        }
      }
    })
  }
  submit(){
    this.errors = {};
    this.submitting=true
    this.dataSRV.postData('one_time_password', this.mfaForm.value).subscribe({
      next:(res:any)=>{
        this.submitting=false
        if(res.status=='success'){
         this.toastSRV.presentToast(res?.message)
         this.router.navigateByUrl('home')
        }
      },
      error:(err) => {
        this.submitting=false
        if(err?.errors){
          this.errors=err?.errors
        } else {
          this.errorHandlerSRV.displayErrorMessage(err, true)
        }
          
        
      }
    })
  }

}
